module.exports = "/_next/static/images/c056ffe5d409d56a7a66e90966b8e47a-value_proposal_md.png.webp";